import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import GiaoDichChoDuyetApi from "service/GiaoDichChoDuyetApi";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";
import { pushNotification } from "utils/notifications";
const DeleteAccessModel = ({ ThuChiId, onClose, LoadDanhSachGiaoDichChoDuyet, ModelTitle }) => {
    const handleConfirm = () => {
        ModelTitle === "Delete" ? onDelete(ThuChiId) : onAccess(ThuChiId);
    };
    const onDelete = async (ThuChiId) => {
        try {
            const res = await DanhSachQuyKhacApi.deleteQuyKhac({ ThuChiId });
            if (res.status === 200) {
                pushNotification("Xóa thành công!", "success", "TOP_CENTER", 1000);
                onClose();
                LoadDanhSachGiaoDichChoDuyet();
            }
            else {
                pushNotification("Lỗi khi xóa giao dịch" + res.data, "error", "TOP_CENTER", 2000);
            }
        } catch (err) {
            console.error("Lỗi khi xóa:", err);
            pushNotification("Không thể xóa. Vui lòng thử lại! " + err, "error", "TOP_CENTER", 2000);
        }
    }
    const onAccess = async (ThuChiId) => {
        try {
            const res = await GiaoDichChoDuyetApi.UpdateStatusGiaoDichChoDuyetByThuChiID({ ThuChiId });
            if (res.status === 200) {
                pushNotification("Cập nhật thành công!", "success", "TOP_CENTER", 1000);
                onClose();
                LoadDanhSachGiaoDichChoDuyet();
            }
            else {
                pushNotification("Lỗi khi cập nhật trạng thái giao dịch" + res.data, "error", "TOP_CENTER", 2000);
            }
        } catch (err) {
            console.error("Lỗi khi cập nhật trạng thái giao dịch:", err);
            pushNotification("Không thể cập nhật trạng thái giao dịch. Vui lòng thử lại! "+err, "error", "TOP_CENTER", 2000);
        }
    }
    const isDelete = ModelTitle === "Delete";
    return (
        <Modal
            show={true}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title" id="myModalLabel16">
                    <span className="btn-icon-right">
                        {isDelete ? (
                            <i className="mdi mdi-delete"></i>
                        ) : (
                            <i className="mdi mdi-check-circle"></i>
                        )}
                    </span>
                    {ModelTitle === "Delete" ? "Xác nhận xóa giao dịch" : "Xác nhận duyệt giao dịch"}
                </h4>
                <button
                    type="button"
                    className="close-popup-new"
                    onClick={onClose}
                >
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <form className="form tat-toan form-horizontal">
                    <div className="form-body">
                        <div className="form-body">
                            <div className="form-group row">
                                <label
                                    className="col-md-12 label-control text-left"
                                    for="projectinput2"
                                >
                                    {ModelTitle === "Delete" ? "Bạn có chắc chắn muốn xóa giao dịch này không?" : "Bạn có chắc chắn muốn duyệt giao dịch này không?"}
                                </label>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-checknew"
                    onClick={handleConfirm}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-check"></i>
                    </span>
                    Xác nhận
                </button>

                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onClose}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteAccessModel;